<script lang="ts">
	import DynamicContent from '$lib/components/DynamicContent.svelte';
	import { Heading, Hr } from 'flowbite-svelte';
	import type { PageData } from './$types';
	import Table from './Table.svelte';
	export let data: PageData;
</script>

<Heading tag="h2" class="mb-8 text-center">{data?.state?.name} Scratch Offs</Heading>
<Hr class="py-8" />
{#if data?.stateContent?.content}
	<DynamicContent content={data?.stateContent?.content} />
	<Hr class="py-8" />
{/if}
{#if data?.stateData?.blurb}
	<DynamicContent content={data?.stateData?.blurb} />
{/if}
<Table items={data?.gamesData?.games} slug={data?.state?.slug} />
